import TagDisplay from './../TagDisplay';


function IntellMockNewReport({article, searchTerm=null, engineName}) {
  let use = false
  return (
    <>
      {use ? <TagDisplay/> : <div></div>}
    </>
  )
}

export default IntellMockNewReport